/************
 * Developed by : Shiva Software Solutions
 * Date : 11-05-2023
 * Descriptions : Route page for report page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const amazonreportpageConfigs = [
  {
    auth: authRole.admins,
    routes: [
      {
        path: '/amazonreports',
        component: React.lazy(() => import('./report')),
      },
    ],
  },
];
